import React, { useContext } from 'react'
import styled from 'styled-components'
import { get } from 'lodash'
import { AppContext } from '../Context'
import theme from '@shared/utils/theme'
import PimpPageHeader from '../components/PimpPageHeader'
import WelcomePageActions from './welcome/WelcomePageActions'
import WelcomePageSimulation from './welcome/WelcomePageSimulation'
import WelcomePageLinks from './welcome/WelcomePageLinks'
import WelcomePageLogout from './welcome/WelcomePageLogout'
import WelcomePageRecords from './welcome/records/WelcomePageRecords'

const WelcomePageContainer = styled.div`
  color: ${ theme.palette.black };
  display: flex;
  flex-direction: column;

  .greeting{
    font-size: 24px;
    letter-spacing: 0.27px;
    margin-left: 20px;
    margin-top: 30px;
  }

  .greeting span {
    font-weight: bold;
  }

  .description {
    margin-left: 20px;
    margin-top: 10px;
    margin-right: 20px;
    font-size: 12px;
    word-break: break-word;
  }
`

function WelcomePage() {
  const {
    employee
  } = useContext(AppContext)

  return (
    employee ? <WelcomePageContainer>
      <PimpPageHeader/>
      <div className="greeting"><span>Bonjour</span> { get(employee, 'firstName') }</div>
      <div className="description">
        <span>
          Cette application vous permet de connaître vos droits à une aide financière,
          ouvrir un dossier, transmettre vos factures mensuelles de la garde de vos
          enfants et obtenir le versement de l’allocation sur votre bulletin de paie.
        </span>
      </div>
      <WelcomePageRecords/>
      { employee && <WelcomePageActions condition={ employee.nbChildren > 0 }/> }
      <WelcomePageSimulation/>
      <WelcomePageLinks/>
      <WelcomePageLogout/>
    </WelcomePageContainer> : <>No employee connected</>
  )
}

export default WelcomePage
